export default function useGridKeys(container, els, onClick) {
	container.addEventListener('keydown', e => {
		const coords = coordsOf(e.target, els);
		if (!coords) return;
		switch (e.key) {
			case 'ArrowLeft': --coords.x; break;
			case 'ArrowRight': ++coords.x; break;
			case 'ArrowUp': --coords.y; break;
			case 'ArrowDown': ++coords.y; break;
			case ' ':
				const el = els[coords.y]?.[coords.x];
				onClick(el);
				e.preventDefault();
				return;
			default: return;
		}
		const el = els[coords.y]?.[coords.x];
		if (!el) return;
		el.el.focus();
		e.preventDefault();
	});
}

function coordsOf(button, els) {
	for (let y = 0; y < els.length; ++y)
		for (let x = 0; x < els[y].length; ++x)
			if (els[y][x].el == button)
				return { x, y };
}
